module.exports = __webpack_public_path__ + "img/maximum.cf1ddede.png";